import NavbarTabs from "./NavbarTabs";
import "../../styles/Navbar.scss";
function DesktopNav(){
    return(
        <>
            <nav className="desktopnav">
                <NavbarTabs/>
            </nav>
        </>
    );
}
export default DesktopNav;